import { IconButton, InputAdornment, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useStyles } from "./styles";
import { useTheme } from "@emotion/react";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

const SearchField = ({
  searchValue,
  setSearchValue,
  placeholderText = "Search",
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const handleClearSearch = () => {
    setSearchValue("");
  };

  return (
    <TextField
      className={classes.searchField}
      slotProps={{
        input: {
          endAdornment: searchValue && (
            <InputAdornment position="end">
              <IconButton onClick={handleClearSearch}>
                <ClearOutlinedIcon className={classes.clearIcon} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      size="small"
      placeholder={placeholderText}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      sx={{ marginTop: 1, width: "98%" }}
    />
  );
};

export default SearchField;

SearchField.propTypes = {
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
};
